import React from 'react';
import { CLIENT_LOGOS } from '../mock';
import PatternBg from './PatternBg';

function LogoTile({ logo }) {
  return (
    <div className="mx-4 flex h-24 min-w-[200px] shrink-0 items-center justify-center rounded-2xl bg-white px-9">
      <img
        src={logo.src}
        alt={`${logo.name} logo`}
        loading="lazy"
        draggable={false}
        className={`w-auto object-contain opacity-90 transition-opacity duration-300 hover:opacity-100 ${logo.imgClass || 'max-h-12'}`}
      />
    </div>
  );
}

function Row({ logos, direction, duration }) {
  // Repeat the real logos enough to fill the viewport, then duplicate the whole
  // set once so the marquee loops seamlessly (translateX -50% == one set width).
  // Duplicates exist ONLY to create the infinite loop, they are not extra clients.
  const times = Math.max(3, Math.ceil(14 / logos.length));
  const base = Array.from({ length: times }).flatMap(() => logos);
  const loop = [...base, ...base];
  return (
    <div className="ob-marquee-wrap ob-fade-x overflow-hidden">
      <div
        className={`ob-marquee ${direction === 'right' ? 'ob-marquee--right' : 'ob-marquee--left'}`}
        style={{ animationDuration: `${duration}s` }}
      >
        {loop.map((logo, i) => (
          <LogoTile key={`${logo.name}-${i}`} logo={logo} />
        ))}
      </div>
    </div>
  );
}

export default function ClientLogos() {
  const rowTop = CLIENT_LOGOS;
  const half = Math.floor(CLIENT_LOGOS.length / 2);
  const rowBottom = [...CLIENT_LOGOS.slice(half), ...CLIENT_LOGOS.slice(0, half)];
  return (
    <section className="relative overflow-hidden border-y border-[var(--ob-line)] bg-[var(--ob-bg-alt)] py-14">
      <PatternBg
        size={118}
        opacity={0.06}
        mask="radial-gradient(100% 150% at 50% 0%, #000 25%, transparent 72%)"
      />
      <div className="relative mx-auto max-w-[1280px] px-5 md:px-8">
        <p className="mb-9 text-center text-xs font-semibold uppercase tracking-[0.22em] text-[var(--ob-ink-soft)]">
          Trusted by these Shopify brands
        </p>
      </div>
      <div className="relative flex flex-col gap-4">
        <Row logos={rowTop} direction="left" duration={94} />
        <Row logos={rowBottom} direction="right" duration={109} />
      </div>
    </section>
  );
}
